"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MintTokenDialog = exports.mintTokenValidationSchema = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("@framework/types");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
var validation_1 = require("./validation");
Object.defineProperty(exports, "mintTokenValidationSchema", { enumerable: true, get: function () { return validation_1.mintTokenValidationSchema; } });
const MintTokenDialog = (props) => {
    const { initialValues } = props;
    const contractType = initialValues.template.components[0].tokenType;
    const disabledOptions = Object.values(types_1.TokenType).filter(tokenType => tokenType !== contractType);
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [1, 2], children: [(0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TemplateAssetInput, { autoSelect: true, required: true, prefix: "template", tokenType: { disabledOptions } }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "account", required: true }), (0, jsx_runtime_1.jsx)(ui_kit_1.FormGrid.Empty, {})] }));
};
exports.MintTokenDialog = MintTokenDialog;
//# sourceMappingURL=index.js.map